/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type CancelDashboardBriefMutationVariables = Types.Exact<{
    id: Types.Scalars['String'];
}>;

export type CancelDashboardBriefMutation = { __typename: 'Mutation'; document: boolean };

export const CancelDashboardBriefDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CancelDashboardBrief' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'document' },
                        name: { kind: 'Name', value: 'cancel' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
export type CancelDashboardBriefMutationFn = Apollo.MutationFunction<
    CancelDashboardBriefMutation,
    CancelDashboardBriefMutationVariables
>;

/**
 * __useCancelDashboardBriefMutation__
 *
 * To run a mutation, you first call `useCancelDashboardBriefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDashboardBriefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDashboardBriefMutation, { data, loading, error }] = useCancelDashboardBriefMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelDashboardBriefMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CancelDashboardBriefMutation,
        CancelDashboardBriefMutationVariables
    >
) {
    return Apollo.useMutation<CancelDashboardBriefMutation, CancelDashboardBriefMutationVariables>(
        CancelDashboardBriefDocument,
        baseOptions
    );
}
export type CancelDashboardBriefMutationHookResult = ReturnType<
    typeof useCancelDashboardBriefMutation
>;
export type CancelDashboardBriefMutationResult =
    Apollo.MutationResult<CancelDashboardBriefMutation>;
export type CancelDashboardBriefMutationOptions = Apollo.BaseMutationOptions<
    CancelDashboardBriefMutation,
    CancelDashboardBriefMutationVariables
>;
